module.exports = __webpack_public_path__ + "static/img/bg-id.3d0b680c.png";